var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSy1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 104,
    viewBox: "0 0 103 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 78.95H32.1773M32.1773 93.65H3M71.0803 78.95H100.258M100.258 93.65H71.0803M58.9231 52H44.3345V71.6H58.9231V52Z",
    stroke: "#C49A6C",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 31L64 14.5M75.9432 27.5C75.9432 33.9978 73.3815 40.2295 68.8217 44.8241C64.2618 49.4188 58.0774 52 51.6288 52C45.1802 52 38.9957 49.4188 34.4359 44.8241C29.8761 40.2295 27.3144 33.9978 27.3144 27.5C27.3144 21.0022 29.8761 14.7705 34.4359 10.1759C38.9957 5.58124 45.1802 3 51.6288 3C58.0774 3 64.2618 5.58124 68.8217 10.1759C73.3815 14.7705 75.9432 21.0022 75.9432 27.5ZM61.3545 71.6H41.903C37.3173 71.6 35.0269 71.6 33.6021 73.0357C32.1773 74.4714 32.1773 76.7793 32.1773 81.4V91.2C32.1773 95.8207 32.1773 98.1286 33.6021 99.5643C35.0269 101 37.3173 101 41.903 101H61.3545C65.9402 101 68.2307 101 69.6555 99.5643C71.0803 98.1286 71.0803 95.8207 71.0803 91.2V81.4C71.0803 76.7793 71.0803 74.4714 69.6555 73.0357C68.2307 71.6 65.9402 71.6 61.3545 71.6Z",
    stroke: "#C49A6C",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSy1);
export default __webpack_public_path__ + "static/media/SY1.e2e849b22445a282b642c2b64003b317.svg";
export { ForwardRef as ReactComponent };